export default __webpack_public_path__ + "static/reviseVideo-c6b5b33388dc3c2f5e00259ab6390b36.webm";